module.exports = __webpack_public_path__ + "static/media/thewest-banner-black-friday.6bd90fb8.png";